/** @deprecated This is only needed to ease the migration for heap events relying on these properties */
export var getCosmosDataProps = function (key) { return ({
    "data-cosmos-key": key,
}); };
